import KSalesmanForm from "kinnect-front/KSalesmen/KSalesmanForm";
import { KAvatarAutocomplete } from "kinnect-general";
import { Salesman } from "kinnect-models";
import { VDialog, VIcon } from "vuetify/lib";

export default {
	name: "SalesmanField",

	extends: KAvatarAutocomplete,

	props: {
		itemText: {
			default: "user.name",
			type: String
		},
		itemValue: {
			default: "id",
			type: String
		},
		noDataText: {
			default: "No salesmen to display",
			type: String
		},
		prependIcon: {
			default: "contacts",
			type: String
		},
		showAddButton: Boolean
	},

	data: () => ( {
		dialogOpen: false
	} ),

	methods: {
		createSalesman( { data: salesman } ) {
			this.$emit( "create", new Salesman( salesman ) );
		}
	},

	render() {
		return <KAvatarAutocomplete
			attrs={{ ...this.$props }}
			on={{ ...this.$listeners }}
			scopedSlots={{ ...this.$scopedSlots }}
		>
			{this.showAddButton && <VDialog
				class="white"
				modal
				persistent
				scopedSlots={{ activator: ( { on } ) => <VIcon on={on}>add_circle</VIcon> }}
				slot="append-outer"
				vModel={this.dialogOpen}
				width="500"
			>
				{this.dialogOpen && <KSalesmanForm
					formTitle="Add a Salesman"
					onClose={() => this.dialogOpen = false}
					onSuccess={this.createSalesman}
				></KSalesmanForm>}
			</VDialog>}
		</KAvatarAutocomplete>;
	}
};
